module.exports = __webpack_public_path__ + "img/dox-reader-loop.bd43821e.gif";